import { Box, Typography } from "@mui/material"
import CropperCommands from "./Cropper/CropperCommands";

function SidebarLeft() {
  return;
  return (
    <Box sx={{ maxWidth: 300 }}>
      <CropperCommands />
    </Box>
  );
};

export  default SidebarLeft;